import 'firebase/firestore';
import 'firebase/auth';
import firebase from 'firebase/app';
import * as fui from 'firebaseui'

let inDev = true;
if (window.location.hostname === 'summitmedicalinstitute.com')
    inDev = false

const LOCAL = !window.location.hostname.includes('summitmedical');


const IN_DEV = inDev;
const IN_PROD = !inDev

const prodFirebaseConfig = {
  apiKey: "AIzaSyAMHHOvKsCRTqZw7RsSGHwV3X3XvOEaAig",
  authDomain: "summit-e1fe1.firebaseapp.com",
  projectId: "summit-e1fe1",
  storageBucket: "summit-e1fe1.appspot.com",
  messagingSenderId: "859059478560",
  appId: "1:859059478560:web:a997a50d1e0cfbf7975c45",
  measurementId: "G-ML4J293EFT"
};


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const devFirebaseConfig = {
  apiKey: "AIzaSyArjGj4QJnlEylDXLUlIrQm0TdSBro8KCI",
  authDomain: "summit-dev-8cc54.firebaseapp.com",
  projectId: "summit-dev-8cc54",
  storageBucket: "summit-dev-8cc54.appspot.com",
  messagingSenderId: "262768226048",
  appId: "1:262768226048:web:c05bf1b9af102d30218de5",
  measurementId: "G-BSTXFV63QS"
};

console.log("LOADING APP dev?", IN_DEV);

const app = firebase.initializeApp(IN_DEV ? devFirebaseConfig : prodFirebaseConfig);

const firestore = firebase.firestore(app); // Initialize firestore
//if (window.location.port === '6001')
//{
//   firestore.useEmulator('localhost', 8080);
//}

/*
firestore.enablePersistence({synchronizeTabs:true}).catch(err =>
{
    console.log('Failed to enable offline access:', err.code)
});
*/

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL); // remember the user even after logging out (vs SESSION)

console.log(app);

export { app, firestore, IN_PROD, IN_DEV, LOCAL };
export default firebase;
